import { Filters } from "../filters";
import { MediaGallery } from "../media-gallery";

export class Product {
	constructor() {

		var mediaGallery = new MediaGallery(document.querySelector('.product .media-gallery'));
	}
}